import { memo } from 'react';
import { useTheme } from '@mui/material';
import NotFoundIllustrationLight from './notFound.svg?react';
import NotFoundIllustrationDark from './notFound_dark.svg?react';

export const NotFoundIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <NotFoundIllustrationDark aria-hidden="true" {...props} />;
    return <NotFoundIllustrationLight aria-hidden="true" {...props} />;
  },
);
